import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-beverages',
  templateUrl: './icon-beverages.component.html',
  styleUrls: ['./icon-beverages.component.scss']
})
export class IconBeveragesComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
